const cityData = [
  {
    name: "Patna",
    categories: ["movers", "cost", "cars", "international"],
    links: [
      "Packers and movers in anandpur",
      "Packers and movers in ashiana nagar",
      "Packers and movers in anishabad",
      "Packers and movers in Bairiya",
      "Packers and movers in Bankipur",
      "Packers and movers in beur",
      "Packers and movers in bari pahari",
      "Packers and movers in Begampur",
      "Packers and movers in Budha colony",
      "Packers and movers in Digha",
      "Packers and movers in Digha ghat",
      "Packers and movers in Fraser road",
      "Packers and movers in Gardanibagh",
      "Packers and movers in Gandhi maidan",
      "Packers and movers in Gulzarbagh field",
      "Packers and movers in Gola road",
      "Packers and movers in keshri nagar",
      "Packers and movers in khajpura",
      "Packers and movers in kalianpur",
      "Packers and movers in kankarbagh",
      "Packers and movers in kadam kuan",
      "Packers and movers in kidwaipuri",
      "Packers and movers in kurthaul",
      "Packers and movers in kurji",
      "Packers and movers in lodipur",
      "Packers and movers in lohia nagar",
      "Packers and movers in machhua toli",
      "Packers and movers in mahendru",
      "Packers and movers in marufganj",
      "Packers and movers in muradpur",
      "Packers and movers in mithapur",
      "Packers and movers in malahi pakri road",
      "Packers and movers in Old jakkanpur",
      "Packers and movers in Patliputra colony",
      "packers and movers in Phulwari sharif",
      "Packers and movers in Hanuman nagar",
      "Packers and movers in Patna City chowk",
      "packers and movers in new punaichak",
      "Packers and movers in Raja bazar",
      "Packers and movers in Rajapur",
      "Packers and movers in saidpur",
      "packers and movers in saguna mor",
      "Packers and movers in Rukanpura",
      "Packers and movers in sadikpur",
      "Packers and movers in shastri nagar",
      "Packers and movers in sheikhpura"
    ],
  },

  {
    name: "Bihar",
    categories: ["movers", "cost", "cars", "international"],
    links: [
      "Packers and movers in Araria",
    "Packers and movers in Arwal",
    "Packers and movers in Aurangabad",
    "Packers and movers in Banka",
    "Packers and movers in Begusarai",
    "Packers and movers in Bhagalpur",
    "Packers and movers in Bhojpur",
    "Packers and movers in Buxar",
    "Packers and movers in Darbhanga",
    "Packers and movers in East Champaran (Motihari)",
    "Packers and movers in Gaya",
    "Packers and movers in Gopalganj",
    "Packers and movers in Jamui",
    "Packers and movers in Jehanabad",
    "Packers and movers in Kaimur (Bhabhua)",
    "Packers and movers in Katihar",
    "Packers and movers in Khagaria",
    "Packers and movers in Kishanganj",
    "Packers and movers in Lakhisarai",
    "Packers and movers in Madhepura",
    "Packers and movers in Madhubani",
    "Packers and movers in Munger (Monghyr)",
    "Packers and movers in Muzaffarpur",
    "Packers and movers in Nalanda",
    "Packers and movers in Nawada",
    "Packers and movers in Patna",
    "Packers and movers in Purnia (Purnea)",
    "Packers and movers in Rohtas",
    "Packers and movers in Saharsa",
    "Packers and movers in Samastipur",
    "Packers and movers in Saran",
    "Packers and movers in Sheikhpura",
    "Packers and movers in Sheohar",
    "Packers and movers in Sitamarhi",
    "Packers and movers in Siwan",
    "Packers and movers in Supaul",
    "Packers and movers in Vaishali"
 
    ],
  },

  {
    name: "Delhi",
    categories: ["movers", "cost", "cars", "international"],
    links: [
      "Packers and movers in Delhi Cantonment",
      "Packers and movers in Dwarka",
      "Packers and movers in Karol Bagh",
      "Packers and movers in Rohini",
      "Packers and movers in Vasant Kunj",
      "Packers and movers in Janakpuri",
      "Packers and movers in Pitampura",
      "Packers and movers in Saket",
      "Packers and movers in Greater Kailash",
      "Packers and movers in Lajpat Nagar",
      "Packers and movers in Connaught Place",
      "Packers and movers in Noida",
      "Packers and movers in Faridabad",
      "Packers and movers in Gurgaon",
      "Packers and movers in Karol Bagh",
      "Packers and movers in Okhla",
      "Packers and movers in Preet Vihar",
      "Packers and movers in Shalimar Bagh",
      "Packers and movers in Paharganj",
      "Packers and movers in Anand Vihar",
      "Packers and movers in Rohini Sector 7",
      "Packers and movers in Nehru Place",
      "Packers and movers in Kalkaji",
      "Packers and movers in Malviya Nagar",
      "Packers and movers in Chattarpur",
      "Packers and movers in Pitampura"
    ]
  },
  {
    name: "Maharashtra",
    categories: ["movers", "cost", "cars", "international"],
    links: [
      "Packers and movers in Mumbai",
      "Packers and movers in Pune",
      "Packers and movers in Nagpur",
      "Packers and movers in Nashik",
      "Packers and movers in Thane",
      "Packers and movers in Aurangabad",
      "Packers and movers in Kolhapur",
      "Packers and movers in Solapur",
      "Packers and movers in Amravati",
      "Packers and movers in Nanded",
      "Packers and movers in Ratnagiri",
      "Packers and movers in Jalgaon",
      "Packers and movers in Kalyan",
      "Packers and movers in Vasai",
      "Packers and movers in Mira Bhayandar",
      "Packers and movers in Dombivli",
      "Packers and movers in Alibaug",
      "Packers and movers in Satara",
      "Packers and movers in Latur",
      "Packers and movers in Chandrapur",
      "Packers and movers in Wardha",
      "Packers and movers in Bhandara",
      "Packers and movers in Gondia",
      "Packers and movers in Palghar",
      "Packers and movers in Karad",
      "Packers and movers in Parbhani"
    ]
  },
  {
    name: "Jharkhand",
    categories: ["movers", "cost", "cars", "international"],
    links: [
      "Packers and movers in Ranchi",
      "Packers and movers in Jamshedpur",
      "Packers and movers in Dhanbad",
      "Packers and movers in Bokaro",
      "Packers and movers in Hazaribagh",
      "Packers and movers in Giridih",
      "Packers and movers in Deoghar",
      "Packers and movers in Dumka",
      "Packers and movers in Ramgarh",
      "Packers and movers in Chaibasa",
      "Packers and movers in Koderma",
      "Packers and movers in Latehar",
      "Packers and movers in Palamu",
      "Packers and movers in Simdega",
      "Packers and movers in Khunti",
      "Packers and movers in Sahibganj",
      "Packers and movers in Godda",
      "Packers and movers in East Singhbhum",
      "Packers and movers in West Singhbhum",
      "Packers and movers in Pakur",
      "Packers and movers in Hazaribagh",
      "Packers and movers in Bokaro Steel City",
      "Packers and movers in Ranchi University",
      "Packers and movers in Jharia"
    ]
  }
,
{
  name: "Uttar Pradesh",
  categories: ["movers", "cost", "cars", "international"],
  links: [
    "Packers and movers in Lucknow",
    "Packers and movers in Noida",
    "Packers and movers in Ghaziabad",
    "Packers and movers in Kanpur",
    "Packers and movers in Agra",
    "Packers and movers in Varanasi",
    "Packers and movers in Meerut",
    "Packers and movers in Aligarh",
    "Packers and movers in Mathura",
    "Packers and movers in Bareilly",
    "Packers and movers in Jhansi",
    "Packers and movers in Moradabad",
    "Packers and movers in Firozabad",
    "Packers and movers in Muzaffarnagar",
    "Packers and movers in Shahjahanpur",
    "Packers and movers in Etawah",
    "Packers and movers in Basti",
    "Packers and movers in Sultanpur",
    "Packers and movers in Rae Bareli",
    "Packers and movers in Azamgarh",
    "Packers and movers in Ballia",
    "Packers and movers in Mau",
    "Packers and movers in Deoria",
    "Packers and movers in Unnao",
    "Packers and movers in Rampur",
    "Packers and movers in Hardoi",
    "Packers and movers in Kannauj",
    "Packers and movers in Sitapur"
  ]
}

    

];

export default cityData;
